import * as React from 'react'
import Layout from '../components/layout'

const AboutPage = () => {
    return <Layout pageTitle="About Me">
        <p>18, freshman at GSU in Pre-Computer Science</p>
    </Layout>
}

export default AboutPage